import { SignInButton } from '@clerk/clerk-react';
import { ArrowRight } from 'lucide-react';

export function LandingNav() {
  return (
    <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-md border-b border-gray-100 z-50">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <img 
            src="/TemasekHoldings_logo.svg" 
            alt="Temasek Holdings" 
            className="h-8"
          />
          <div className="h-8 w-px bg-gray-300" />
          <img
            src="/advancelogo.png"
            alt="Advance"
            className="h-6"
          />
        </div>
        
        <SignInButton mode="modal">
          <button className="px-6 py-2 bg-black text-white rounded-lg text-sm font-medium hover:bg-gray-900 transition-colors flex items-center gap-2">
            Sign In
            <ArrowRight className="w-4 h-4" />
          </button>
        </SignInButton>
      </div>
    </nav>
  );
}
